module.exports = __webpack_public_path__ + "img/logo.477b2d26.svg";